export default [
  {
    path: "/fatura-tip",
    name: "fatura_tip",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "fatura_tip.Baslik",
      yetki: { k: [1310002] },
    },
  },
]
